import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { ANCHOR_CONVERTER_TOKEN, AnchorConverter } from './anchor.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        anchorFeature: {
          module: () => import('./anchor.module').then((m) => m.AnchorModule),
          cmsComponents: ['anchor']
        },
      }
    }),
    {
      provide: ANCHOR_CONVERTER_TOKEN,
      useExisting: AnchorConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        anchor: ANCHOR_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class AnchorFeatureModule {}
